'use strict';

var retirement = require('./dynamic-retirement');
var education = require('./dynamic-education');
var holidays = require('./dynamic-holidays');
var purchase = require('./dynamic-purchase');
var freedom = require('./dynamic-freedom');

function adjustDefaults(age, category) {
  switch (category) {
    case 'retirement':
      return retirement[age];
    case 'education':
      return education[age];
    case 'holidays':
      return holidays[age];
    case 'purchase':
      return purchase[age];
    case 'freedom':
      return freedom[age];
    default:
      return {};
  }
}

module.exports = adjustDefaults;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/config/adjust-defaults.js
// module id = 214
// module chunks = 0